import { App } from 'vue'
import UrlInput from './LpUrlInput.vue'

UrlInput.install = (Vue: App) => {
  Vue.component(UrlInput.name, UrlInput)
}

export default UrlInput
